import { useState } from "react";
import { useTranslation } from "react-i18next";
import AgentLibrary from "./AgentLibrary";
import AgentEditor from "./AgentEditor";
import AgentRuns from "./AgentRuns";
import ApprovalsInbox from "./ApprovalsInbox";
import TriggersTab from "./TriggersTab";
import WorkflowsTab from "./WorkflowsTab";
import "./AdminCollections.css";

const TAB_LABELS = { library: "agents.tabLibrary", workflows: "agents.tabWorkflows", runs: "agents.tabRuns",
  approvals: "agents.tabApprovals", triggers: "agents.tabTriggers" };

/** Agents tab: the library (create/edit/share agents), workflows, the runs (start/follow/approve)
 * and the approvals inbox (everything waiting for the user's decision). */
export default function AgentsTab({ database }) {
  const { t } = useTranslation();
  const [view, setView] = useState("library");
  const [editing, setEditing] = useState(null);       // null | "new" | agent
  const [startAgent, setStartAgent] = useState(null);

  if (editing) {
    return <AgentEditor database={database} agent={editing === "new" ? null : editing}
                        onDone={() => setEditing(null)} />;
  }
  return (
    <>
      <nav className="ac-subtabs" aria-label={t("agents.libraryTitle")}>
        {Object.keys(TAB_LABELS).map((v) => (
          <button key={v} type="button" className="ds-chip" aria-pressed={view === v} onClick={() => setView(v)}>
            {t(TAB_LABELS[v])}
          </button>
        ))}
      </nav>
      {view === "library" && <AgentLibrary database={database} onEdit={setEditing}
                                           onStart={(agent) => { setStartAgent(agent); setView("runs"); }} />}
      {view === "workflows" && <WorkflowsTab database={database} />}
      {view === "runs" && <AgentRuns database={database} startAgent={startAgent} onStarted={() => setStartAgent(null)} />}
      {view === "approvals" && <ApprovalsInbox />}
      {view === "triggers" && <TriggersTab />}
    </>
  );
}
